import {
  AppContainer,
  AppContent,
  UnloggedAppContainer,
  ContentContainer,
} from './AppLayout.styles';
import { SupportInfoFooter } from '../SupportInfoFooter/SupportInfoFooter';
import { useAuth } from 'auth/hooks/useAuth';
import { useSecurity } from 'auth/hooks/useSecurity';
import { LoginPhase } from 'navigation/models/login-phase';
import { AppHeader } from '../AppHeader';
import { AppBreadcrumb, Menu } from '../Menu';
import { Container } from 'react-bootstrap';
import { PageTitle } from 'shared/components/Fonts';
import { LogoutButton } from '../ActionsMenu/LogoutButton';
import { ConfirmBanner } from './components/ConfirmBanner';
import { UNCONFIRMED } from 'auth/constants/MailStatus';
import { useAuthService } from 'auth/services/useAuthService';
import { useCoreService } from 'core/services/useCoreService';
import { useUserService } from 'user/services/useUserService';
import { useLocation } from 'react-router-dom';
import {
  CONFIRMATION_EMAIL_PATH,
  RECOVER_PASSWORD_PATH,
  RESET_PASSWORD_PATH,
} from 'user/routes';

const getTitle = (phase: LoginPhase, pathname: string): string => {
  switch (phase) {
    case LoginPhase.LOGIN:
      break;
    case LoginPhase.LOGOUT:
      return null;
    case LoginPhase.EXPIRED_PASSWORD:
      return 'Cambiar Contraseña';
    case LoginPhase.LOGGED_IN:
      return 'Registrar Email';
    case LoginPhase.EMAIL_REQUIRED_BLOCKED:
      return 'Acceso Bloqueado';
    default:
      break;
  }
  if (pathname.startsWith(CONFIRMATION_EMAIL_PATH.replace(/:[^/]+$/, ''))) {
    return 'Confirmación de Email';
  } else if (pathname.startsWith(RECOVER_PASSWORD_PATH)) {
    return 'Reestablecer Clave de Acceso';
  } else if (pathname.startsWith(RESET_PASSWORD_PATH.replace(/:[^/]+$/, ''))) {
    return 'Cambiar Clave de Acceso';
  }
  return null;
};

export function AppLayout({ children }) {
  const { user } = useAuth();
  const { loginPhase } = useSecurity();
  const location = useLocation();

  // Registramos los servicios cuando cargamos la aplicacion
  useAuthService();
  useCoreService();
  useUserService();

  if (location.pathname.match(/^\/(adm\/)?login$/)) {
    return <>{children}</>;
  }

  if (user && loginPhase === LoginPhase.LOGGED_IN) {
    return (
      <AppContainer>
        <Menu />
        <ContentContainer>
          <AppHeader />
          {user.mailStatus === UNCONFIRMED && <ConfirmBanner mail={user.mail} />}
          <AppContent>
            <AppBreadcrumb />
            {children}
          </AppContent>
          <SupportInfoFooter />
        </ContentContainer>
      </AppContainer>
    );
  }

  return (
    <UnloggedAppContainer>
      <div className="header">
        <Container>
          <div className="title-container">
            <div className="title">
              <PageTitle>{getTitle(loginPhase, location.pathname)}</PageTitle>
            </div>
            {user && (
              <div className="icon">
                <LogoutButton />
              </div>
            )}
          </div>
        </Container>
      </div>
      <div className="content">{children}</div>
    </UnloggedAppContainer>
  );
}
